import Box from "../Box";
import { useEffect, useState } from "react";
import { OrderProps } from "styled-system";
import { useLocation } from "react-router";
import styled from "styled-components";
import Bar from "../Bar";
import useBreakPoint from "../../utils/useBreakPoint";
import { useTranslation } from "react-i18next";
import { Range } from "../../utils/range";
import { useRange } from "../../context/rangeContext";

type SelectBarProps = OrderProps & {
  options: {
    label: string;
    value: string;
    range?: Range;
  }[];
  backgroundColor?: string;
};

const BoxCustom = styled(Box)<{ backgroundColor?: string }>`
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
`;

const SelectBar = ({ options, ...rest }: SelectBarProps) => {
  const router = useLocation();
  const isBreak = useBreakPoint();
  const [activeTab, setActiveTab] = useState(router?.pathname);
  const { setKpiRange, getKpiRange } = useRange();
  const { t } = useTranslation();

useEffect(() => {
    if (router?.pathname) {
      setActiveTab(router.pathname);
    }
  }, [router?.pathname]);

  useEffect(() => {
    const currentPath = activeTab || "";
    const matchedOption = options?.find((opt) => 
      currentPath.includes(opt.value.replace("/region/", ""))
    );

    const currentKpi = getKpiRange("kpi_region");

    if (matchedOption?.range && currentKpi !== matchedOption.range) {
      setKpiRange("kpi_region", matchedOption.range);
    }
  }, [activeTab, options, setKpiRange, getKpiRange]);

  return (
    <BoxCustom
      display="flex"
      flexDirection="row"
      justifyContent={"space-between"}
      alignItems="flex-start"
      width={isBreak === "phone" ? "328px" : "345px"}
      bg={rest.backgroundColor ? rest.backgroundColor : "white"}
      backgroundColor={rest.backgroundColor ? rest.backgroundColor : "white"}
      p={1}
      borderRadius={1}
      data-testid="barTabs"
      {...rest}
    >
      {options?.map((e) => (
        <Bar
          key={t(e?.label)}
          tabName={t(e?.label)}
          isActive={activeTab?.includes(e?.value)}
          page={e?.value}
          bg={rest.backgroundColor ? rest.backgroundColor : "white"}
        />
      ))}
    </BoxCustom>
  );
};

export default SelectBar;
